import {
  Users,
  Building2,
  UserPlus,
  School,
  GraduationCap,
  BriefcaseBusiness,
  BadgePercent,
  WalletCards,
} from "lucide-react";

const formatNumber = (value) => {
  if (typeof value === "string" && value.trim().endsWith("%")) {
    return value;
  }

  return Number(value || 0).toLocaleString();
};

const normalize = (value = "") => value.toLowerCase().trim();

// Icon per metric, keyed by the sheet's own label so it stays correct regardless of row order.
const ICON_BY_LABEL = {
  "overall admission": <Users size={18} />,
  "current sitting strength": <Building2 size={18} />,
  "admission ay 27-28": <UserPlus size={18} />,
  "total campuses": <School size={18} />,
  "total teachers": <GraduationCap size={18} />,
  "total non teaching staff": <BriefcaseBusiness size={18} />,
  "total tc percentage": <BadgePercent size={18} />,
  "total term i fee collected": <WalletCards size={18} />,
};

const cardStyles = [
  { bgColor: "bg-pink-100", iconBg: "bg-fuchsia-700", subtitleColor: "text-pink-600" },
  { bgColor: "bg-sky-100", iconBg: "bg-sky-600", subtitleColor: "text-sky-600" },
  { bgColor: "bg-red-100", iconBg: "bg-red-500", subtitleColor: "text-red-500" },
  { bgColor: "bg-yellow-100", iconBg: "bg-yellow-500", subtitleColor: "text-yellow-600" },
  { bgColor: "bg-lime-100", iconBg: "bg-lime-500", subtitleColor: "text-lime-600" },
  { bgColor: "bg-teal-100", iconBg: "bg-teal-600", subtitleColor: "text-teal-600" },
  { bgColor: "bg-orange-100", iconBg: "bg-orange-500", subtitleColor: "text-orange-600" },
  { bgColor: "bg-emerald-100", iconBg: "bg-emerald-600", subtitleColor: "text-emerald-600" },
];

const StatsCards = ({ data }) => {
  const cards = (data?.dashboardTotalModel || []).map((card, index) => ({
    id: card.id,
    title: card.total,
    value: formatNumber(card.count),
    subtitle: "Group Total",
    icon: ICON_BY_LABEL[normalize(card.total)] || <Building2 size={18} />,
    ...cardStyles[index % cardStyles.length],
  }));

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {cards.map((card) => (
        <div
          key={card.id}
          className={`${card.bgColor} rounded-2xl p-4 transition hover:scale-[1.02]`}
        >
          <div
            className={`${card.iconBg} mb-2 flex h-8 w-8 items-center justify-center rounded-lg text-white shadow-md`}
          >
            {card.icon}
          </div>

          <h3 className="text-sm font-semibold leading-snug text-slate-600">
            {card.title}
          </h3>

          <p className="mt-1 text-2xl font-bold text-slate-800">
            {card.value}
          </p>

          <p className={`mt-0.5 text-xs font-medium ${card.subtitleColor}`}>
            {card.subtitle}
          </p>
        </div>
      ))}
    </div>
  );
};

export default StatsCards;
